import '@/pages/home/assets/scss/page/login/index.scss';
import React, { useEffect, useState } from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import AccountnameLogin from './components/AccountnameLogin';
import EmailLogin from './components/EmailLogin';
import EmailLoginCode from './components/EmailLoginCode';
import EmailRegister from './components/EmailRegister';
import EmailRegisterSuccess from './components/EmailRegisterSuccess';
import EmailForgetPassword from './components/EmailForgetPassword';
import EmailResetPasswords from './components/EmailResetPasswords';
import IdpModal from './components/IdpListModal';
import ErrorAlert from './components/ErrorAlert';
import * as service from '@/pages/home/services/login';
import { history, getLocale, setLocale, useIntl } from 'umi';
import { LANGUAGE_CN, LANGUAGE_EN, LOGIN_14_DAYS_KEY, IS_GLOBAL, IS_WOA, ENV, IS_DEVICE_MOBILE } from '@/pages/home/_config/config';
import { getImg } from '@/pages/home/_config/getImgs';
import { getBasePath, storage } from '@/utils/utils';
import { IVerifyType, IRegisterInfoType, SSOInfoType, FetchSSOInfoResultType, FetchSSOInfoItemType } from './_config/constant';
import { getErrorMessage, isAllowDomain } from './_config/common';
import GoogleIcon from '@/pages/home/assets/svg/login/google.svg';
import TencentIcon from '@/pages/home/assets/svg/login/tencent.svg';
import identityProviderFun from '@/pages/home/utils/identityProviderFun';
import OktaIcon from '@/pages/home/assets/svg/login/okta.svg';
import CommonBubble from '@/pages/home/components/CommonBubble';
import { useSize } from 'ahooks';
import classNames from 'classnames';
import { getRedirectUrlByEmail } from '@home/utils/userEmail';

const isValidResetToken = (token: any) => token;

export default () => {
  const local = getLocale();
  const isEngish = local !== LANGUAGE_CN;
  const { formatMessage } = useIntl(); // 中英切换方法
  // 错误告警提示
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState<string | React.ReactNode>('');
  const isOnlineEnv = ['pro','pre'].includes(ENV);

  function handleLocale() {
    // setIsEngish(!isEngish)
    const value = local === LANGUAGE_CN ? LANGUAGE_EN : LANGUAGE_CN;
    setLocale(value, false);
  }
  const LOGIN_MODE = {
    DATA_BRAIN_ACCOUNT: '1',
    // QQ: '2',
    EMAIL: '3',
  };

  const {token: resetToken, email: resetEmail, redirect, loginType} = history.location.query || {};
  const isAccountLogin = loginType === 'account';

  const [loginMode, setLoginMode] = useState(
    isAccountLogin || (!isOnlineEnv && !IS_GLOBAL) ? LOGIN_MODE.DATA_BRAIN_ACCOUNT : LOGIN_MODE.EMAIL
  );

  /** 邮件和邮件密码 */
  const [valueEmail, setValueEmail] = useState<string>('');
  const [valueEmailPadssword, setValueEmailPadssword] = useState<string>('');
  /** 邮件登陆验证码时间 */
  const [expires, setExpires] = useState(0);
  // 邮件发送验证码
  const [isEmailCode, setIsEmail] = useState(false);
  const [verifyType, setVerifyType] = useState<IVerifyType>('emailLogin');
  const [registerInfo, setRegisterInfo] = useState<IRegisterInfoType | null>(null);
  // 邮箱注册
  const [isEmailRegister, setIsEmailRegister] = useState(false);
  // 邮箱注册成功
  const [isEmailRegisterSuccess, setIsEmailRegisterSuccess] = useState(false);
  // 邮箱重置密码
  const [isEmailResetPasswords, setIsEmailResetPasswords] = useState(isValidResetToken(resetToken));
  // 邮箱忘记密码
  const [isEmailForgetPassword, setIsEmailForgetPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  // 14天免登陆
  const [login14Days, setLogin14Days] = useState(true);
  const [idpVisible, setIdpVisible] = useState(false);
  const [idpInfo, setIdpInfo] = useState<SSOInfoType | null>(null);
  const SSOInfoId = localStorage.getItem('companyId');
  const googleType='General';
  const googleIdentityProvider='Google';

  useEffect(() => {
    IS_GLOBAL && getIdpList();
  }, []);

  // 获取OIDC配置
  const getIdpList = async () => {
    try {
      await service.getSSOList().then((res:FetchSSOInfoResultType) => {
        const googleData = res?.authentications?.find(
          (item: FetchSSOInfoItemType) =>
            item.group === googleType && item.identity_provider === googleIdentityProvider,
        );
        const ssoData = res?.authentications?.filter((item: FetchSSOInfoItemType) => item.group !== googleType) || [];
        const options = ssoData.map((item: FetchSSOInfoItemType) => {
          return {
            text: (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ height: '22px' }}>{item.group}</div>
                <img height={22} src={item.icon} />
              </div>
            ),
            value: JSON.stringify({
              loginDomain: item.login_domain,
              clientId: item.client_id,
              identityProvider: item.identity_provider,
              group: item.group,
              id: item.id,
            }),
            company: item.group,
          };
        });
        // 查找后端返回数据中有没有存储的SSOInfoId
        const findIdp = res?.authentications?.find((item: FetchSSOInfoItemType) => item.id === SSOInfoId);
        setIdpInfo({
          googleInfo: googleData || null,
          IdpList: options || null,
          historySSOInfo: findIdp || null,
        });
      });
    } catch (err: any) {
      onError(err?.msg, err?.code);
    }
  };

  const onError = (message: string, errcode?: number) => {
    const msg = getErrorMessage(message, errcode);
    // oa用户注册特别提示，加上重置密码link
    if (errcode === 40016) {
      setAlertMessage(
        <>
          {formatMessage({ id: 'dbh_login_register_fail_oa_part1' })}
          <a
            onClick={() => {
              setIsEmailRegister(false);
              setAlertVisible(false);
            }}
          >{` ${formatMessage({
              id: 'dbh_login_register_fail_oa_part2',
            })} `}</a>
          {formatMessage({ id: 'dbh_login_register_fail_oa_part3' })}
        </>,
      );
      setAlertVisible(true);
      return;
    }
    if (msg) {
      setAlertMessage(formatAlertMessage(msg));
      setAlertVisible(true);
    }
  };

  const OALogin = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);
      await service.login({
        login_type: 'WOA',
      });
      onLoginSuccess(false);
      // setLoading(false);
    } catch (err: any) {
      if (err?.code === 4007) {
        // 4007 Login failed
        onError('dbh_login_oa_login_failed');
      } else {
        onError(err?.msg, err?.code);
      }
      setLoading(false);
    }
  };

  const globalOALogin = async () => {
    const rUrl = redirect || window.origin;
    window.location.replace(`${window.location.origin}/api/v1/auth/saml/login?returnUrl=${encodeURIComponent(rUrl as string)}`);
  };

  const onLoginSuccess = (isLogin14Days: boolean | undefined) => {
    // const { redirect, type } = history.location.query || {}
    // if (redirect && (typeof redirect === 'string') && type === 'out' && DOMAIN.test(redirect)) {

    // 登出时，已不再添加 type=out 的查询参数了，所以这里 应该也要移除 查询参数的type=out 的判断
    storage.setItem(LOGIN_14_DAYS_KEY, isLogin14Days === undefined ? login14Days : isLogin14Days);
    if (typeof redirect === 'string' && isAllowDomain(redirect)) {
      window.location.replace(redirect);
    } else {
      // 检查邮箱后缀跳转
      if (valueEmail) {
        const redirectUrl = getRedirectUrlByEmail(valueEmail);
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }
      }
      //  如果是移动端（databrain-mobile.intlgame.com），跳转到intelligence
      if (IS_DEVICE_MOBILE) {
        window.location.replace('/intelligence');
        return;
      }

      window.location.replace(`${getBasePath()}/home`);
    }
  };

  const changeLoginMethod = () => {
    const newLoginMode = loginMode === LOGIN_MODE.EMAIL ? LOGIN_MODE.DATA_BRAIN_ACCOUNT : LOGIN_MODE.EMAIL;
    setLoginMode(newLoginMode);
  };

  const formatAlertMessage = (id: string) => {
    if (id && typeof id === 'string') {
      return formatMessage({ id, defaultMessage: id });
    }
    return id;
  };

  return (
    <div className={classNames('login', { 'login-mobile': IS_DEVICE_MOBILE })}>
      <CommonLoginTextTips {...{
        effect: idpInfo
      }}/>
      <div className="login-inner">
        <div className="login-logo">
          <img src={getImg('login-logo')} alt="" />
        </div>
        <div className="login-cover">
          <img src={getImg('login-bg')} alt="" />
        </div>
        <div className="login-text">
          {/* Present the massive <br /> global game market to you */}
          {formatMessage(
            { id: 'dbh_login_image_title' },
            {
              br: <br />,
            },
          )}
        </div>

        <div className="login-wrap">
          {/* 告警提示 */}
          {alertVisible && (
            <ErrorAlert
              visible={alertVisible}
              onClose={() => setAlertVisible(false)}
              message={alertMessage}
            />
          )}
          <Bubble
            arrowPointAtCenter
            placement="bottom-end"
            placementOffset={10}
            content={IS_DEVICE_MOBILE ? '' : (!isEngish ? 'Switch To English ' : '切换中文')}
          >
            <div className="login-language" onClick={handleLocale}>
              <SvgIcon
                className="eg-cn"
                type={isEngish ? 'english' : 'chinese'}
              />
            </div>
          </Bubble>
          <div className="login-information-outer">
            <div className="login-information">
              {isEmailCode /** 邮件发送验证码 */ ? (
                <EmailLoginCode
                  login14Days={login14Days}
                  verifyType={verifyType}
                  registerInfo={registerInfo}
                  expires={expires}
                  valueEmail={valueEmail}
                  valuePadssword={valueEmailPadssword}
                  onBack={() => {
                    setIsEmail(false);
                  }}
                  onLoginSuccess={onLoginSuccess}
                  onError={onError}
                />
              ) : isEmailRegister /** 邮箱注册 */ ? (
                <EmailRegister
                  getEmailRegisterBtn={(
                    params: IRegisterInfoType,
                    expires: number,
                  ) => {
                    setValueEmail(params?.email);
                    setValueEmailPadssword(params?.password);
                    setExpires(expires);
                    setIsEmailRegister(false);
                    // 注册成功页面改为输入验证码页面
                    setIsEmail(true);
                    setVerifyType('register');
                    setRegisterInfo(params);
                    // setIsEmailRegisterSuccess(true)
                  }}
                  // oa账号已存在，注册失败，获取当前输入邮箱
                  getEmailInfo={(email: string) => {
                    setValueEmail(email);
                  }}
                  onBack={() => {
                    setIsEmailRegister(false);
                  }}
                  onError={onError}
                />
              ) : isEmailRegisterSuccess /** 邮箱注册成功 */ ? (
                <EmailRegisterSuccess
                  onBack={() => {
                    setIsEmailRegisterSuccess(false);
                  }}
                />
              ) : isEmailResetPasswords /** 邮箱重置密码 */ ? (
                <EmailResetPasswords
                  valueEmail={resetEmail}
                  token={resetToken}
                  onBack={() => {
                    setIsEmailResetPasswords(false);
                  }}
                  onError={onError}
                />
              ) : isEmailForgetPassword /** 邮箱忘记密码 */ ? (
                <EmailForgetPassword
                  email={valueEmail}
                  onBack={() => {
                    setIsEmailForgetPassword(false);
                  }}
                  onError={onError}
                />
              ) : (
                <div className="login-cont">
                  {loginMode === LOGIN_MODE.EMAIL ? (
                    <EmailLogin
                      oaLoading={loading}
                      login14Days={login14Days}
                      setLogin14Days={setLogin14Days}
                      email={valueEmail}
                      password={valueEmailPadssword}
                      getEmailBtn={(
                        email: string,
                        password: string,
                        expires: number,
                      ) => {
                        setValueEmail(email);
                        setValueEmailPadssword(password);
                        setExpires(expires);
                        setIsEmail(true);
                        setIsEmailRegister(false);
                        setVerifyType('emailLogin');
                      }}
                      getRegister={() => {
                        setIsEmailRegister(true);
                      }}
                      getForgetPassword={(email: string, password: string) => {
                        setValueEmail(email);
                        setValueEmailPadssword(password);
                        setIsEmailRegisterSuccess(false);
                        setIsEmailForgetPassword(true);
                      }}
                      onError={onError}
                    />
                  ) : (
                    <AccountnameLogin
                      oaLoading={loading}
                      getRegister={() => {
                        setIsEmailRegister(true);
                      }}
                      login14Days={login14Days}
                      setLogin14Days={setLogin14Days}
                      onLoginSuccess={onLoginSuccess}
                      onError={onError}
                    />
                  )}
                  {!IS_GLOBAL ? (
                    <div className="login-cont-type">
                      {(!isOnlineEnv || isAccountLogin || IS_WOA) && (
                        <div className="login-cont-type-text">
                          {' '}
                          {formatMessage({ id: 'dbh_login_other_methods' })}
                        </div>
                      )}
                      <div className="login-cont-type-list">
                        {IS_WOA && (
                          <div
                            className="login-cont-type-item item-oa"
                            onClick={() => {
                              OALogin();
                            }}
                          >
                            <div className="login-cont-type-icon dbh_login_type_woa">OA</div>
                            <div className="login-cont-type-info">
                              {' '}
                              {formatMessage({ id: 'dbh_login_OA' })}
                            </div>
                          </div>
                        )}
                        {/* dev test 以及 账号入口进来 保持原样 */}
                        {(!isOnlineEnv || isAccountLogin) && (
                          <div className="login-cont-type-item item-other">
                            <div
                              onClick={changeLoginMethod}
                              className={classNames('login-cont-type-icon', {
                                'dbh_login_type_email': loginMode !== LOGIN_MODE.EMAIL,
                                'dbh_login_type_user': loginMode === LOGIN_MODE.EMAIL,
                              })}
                            >
                              <SvgIcon
                                type={
                                  loginMode === LOGIN_MODE.EMAIL
                                    ? 'user'
                                    : 'email-m'
                                }
                                className={
                                  loginMode === LOGIN_MODE.EMAIL
                                    ? 'user'
                                    : 'email-m'
                                }
                              />
                            </div>
                            <div className="login-cont-type-info">
                              {loginMode === LOGIN_MODE.EMAIL
                                ? formatMessage({ id: 'dbh_login_account' })
                                : formatMessage({ id: 'dbh_login_email' })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="login-cont-global-type">
                      <div className="login-cont-global-type-text">
                        {' '}
                        {formatMessage({ id: 'dbh_login_other_methods' })}
                      </div>
                      <div className="login-cont-global-type-list">
                        {/* global-OA登录 */}
                        {!IS_DEVICE_MOBILE && (
                          <div
                            className="login-cont-global-type-item dbh_login_type_woa"
                            onClick={() => {
                              globalOALogin();
                            }}
                          >
                            <img src={TencentIcon} alt="" width={28} />
                            <div className="login-cont-global-type-info">
                              {formatMessage(
                                { id: 'dbh_login_type_sso' },
                                { type: 'OA' },
                              )}
                            </div>
                          </div>
                        )}
                        {/* google登录 */}
                        {idpInfo?.googleInfo && (
                          <CommonBubble
                            placement="bottom-start"
                            overlayClassName="login-sso-bubble"
                            content={formatMessage({
                              id: 'dbh_login_type_google_tip',
                            })}
                          >
                            <div
                              className="login-cont-global-type-item dbh_login_type_google"
                              onClick={() => {
                                return (
                                  idpInfo?.googleInfo &&
                                  identityProviderFun({
                                    ...idpInfo?.googleInfo,
                                    loginDomain: idpInfo.googleInfo.login_domain,
                                    clientId: idpInfo.googleInfo.client_id,
                                    identityProvider: 'Google',
                                  })
                                );
                              }}
                            >
                              <img src={GoogleIcon} alt="" width={28} />
                              <div className="login-cont-global-type-info">
                                {' '}
                                {formatMessage({ id: 'dbh_login_type_google' })}
                              </div>
                            </div>
                          </CommonBubble>
                        )}
                        {/* okta */}
                        {idpInfo?.IdpList && idpInfo?.IdpList.length > 0 && (
                          <CommonBubble
                            placement="bottom-start"
                            overlayClassName="login-sso-bubble"
                            content={
                              idpInfo?.historySSOInfo
                                ? formatMessage(
                                  { id: 'dbh_login_type_sso' },
                                  {
                                    type: `${idpInfo?.historySSOInfo.group}-${idpInfo?.historySSOInfo.identity_provider}`,
                                  },
                                )
                                : null
                            }
                          >
                            <div
                              className="login-cont-global-type-item dbh_login_type_okta"
                              onClick={() => {
                                if (idpInfo?.historySSOInfo) {
                                  return identityProviderFun({
                                    ...idpInfo?.historySSOInfo,
                                    loginDomain:
                                      idpInfo.historySSOInfo.login_domain,
                                    clientId: idpInfo.historySSOInfo.client_id,
                                    identityProvider:
                                      idpInfo.historySSOInfo.identity_provider,
                                  });
                                }
                                setIdpVisible(true);
                              }}
                            >
                              <img src={OktaIcon} alt="" width={28} />
                              <div className="login-cont-global-type-info">
                                {' '}
                                {formatMessage(
                                  { id: 'dbh_login_type_sso' },
                                  { type: 'OKTA' },
                                )}
                              </div>
                            </div>
                          </CommonBubble>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {
                <div className="login-info">
                  {!IS_WOA && !IS_GLOBAL ? (
                    <div>
                      {formatMessage({ id: 'dbh_login_email_desc' })}
                      <a href="https://databrain.woa.com">
                        {' '}
                        https://databrain.woa.com{' '}
                      </a>
                    </div>
                  ) : null}
                  <div>
                    {formatMessage({ id: 'dbh_login_contact_ivyyfchen' })}
                    <a href="mailto:ivyyfchen@tencent.com">
                      {' '}
                      ivyyfchen@tencent.com
                    </a>
                    .
                  </div>
                </div>
              }
              {idpVisible && (
                <IdpModal
                  visible={idpVisible}
                  idpList={idpInfo?.IdpList}
                  onClose={() => setIdpVisible(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export const CommonLoginTextTips = ({
  visible,
  effect,
  ...restProps
}: {
  effect: unknown | null;
  visible?: boolean;
}) => {
  const [position, setPosition] = useState('');
  const { formatMessage } = useIntl(); // 中英切换方法
  // 执行动机: 表单出现error，位置会有偏差，这里强制刷新偏移px
  const size = useSize(document.querySelector('.login-cont-account'));
  const { type: loginSussesType } = storage.getItem('_dbh_login_type') || {};
  const mapKey = {
    WOA: 'dbh_login_type_woa',
    'WOA SAML': 'dbh_login_type_woa',
    Email: 'dbh_login_type_email',
    Basic: 'dbh_login_type_user',
    Google: 'dbh_login_type_google',
    OKTA: 'dbh_login_type_okta'
  };
  useEffect(() => {
    setPosition(document.querySelector(`.${mapKey[loginSussesType]}`));
  }, [loginSussesType, mapKey, effect]);
  // 移动端不显示上次登录提示
  if (IS_DEVICE_MOBILE) {
    return null;
  }
  // 如果没有定位元素，直接返回空组件
  if (!position) {
    return null;
  }
  return (
    <CommonBubble
      updateDeps={[size, getLocale(), effect]}
      onClick={(e) => e.stopPropagation()}
      className="dbh-login-type-bubble"
      visible={position && true}
      arrowPointAtCenter
      placement={"right-end"}
      positionFixed={false}
      escapeWithReference
      flipped={false}
      content={formatMessage({ id: 'dbh_login_last_login' })}
      referenceElement={position}
      {...restProps}
    />
  );
};
